// import { io, Socket } from "socket.io-client";

// const SOCKET_URL =
//   process.env.NEXT_PUBLIC_SOCKET_URL ||
//   process.env.NEXT_PUBLIC_API_URL ||
//   "http://localhost:3001";

// type UserRole = "ADMIN" | "DOCTOR" | "HOSPITAL" | "PATIENT";

// interface SocketUser {
//   userId: string;
//   role: UserRole;
//   token: string;
// }

// declare global {
//   interface Window {
//     __socket?: Socket;
//     __socketUser?: SocketUser;
//   }
// }

// function createSocket(token: string): Socket {
//   return io(SOCKET_URL, {
//     auth: { token: token || "" },
//     transports: ["websocket", "polling"],
//     reconnection: true,
//     reconnectionAttempts: Infinity,
//     reconnectionDelay: 1000,
//     reconnectionDelayMax: 5000,
//     timeout: 20000,
//     autoConnect: true,
//     withCredentials: true,
//   });
// }

// export function getSocket(): Socket | null {
//   if (typeof window === "undefined") return null;
//   return window.__socket || null;
// }

// /**
//  * Initialize socket after login.
//  * token can be passed directly (preferred) or falls back to localStorage.
//  */
// export function initSocket({
//   userId,
//   role,
//   token,
// }: {
//   userId: string;
//   role: UserRole;
//   token?: string; // now optional — will fall back to localStorage
// }): Socket | null {
//   if (typeof window === "undefined") throw new Error("Socket can only run in browser");

//   // Resolve token: use passed token first, then fall back to localStorage
//   const storedKey =
//     role === "DOCTOR"
//       ? "doctor_access_token"
//       : role === "HOSPITAL"
//       ? "hospital_access_token"
//       : "admin_access_token";

//   const resolvedToken = (token?.trim()) || localStorage.getItem(storedKey) || "";

//   if (!resolvedToken) {
//     console.warn("⚠️ initSocket: token is empty; socket init skipped");

//     // Return existing connected socket if same user/role
//     if (
//       window.__socket?.connected &&
//       window.__socketUser?.userId === userId &&
//       window.__socketUser?.role === role
//     ) {
//       return window.__socket;
//     }
//     return null;
//   }

//   // Reuse existing socket if same user + connected
//   if (
//     window.__socket?.connected &&
//     window.__socketUser?.userId === userId &&
//     window.__socketUser?.role === role
//   ) {
//     return window.__socket;
//   }

//   // Disconnect previous socket
//   if (window.__socket) {
//     window.__socket.removeAllListeners();
//     window.__socket.disconnect();
//   }

//   const socket = createSocket(resolvedToken);

//   socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
//   socket.on("disconnect", (reason) => console.log("❌ Socket disconnected:", reason));
//   socket.on("connect_error", (err) => console.error("❌ Socket connection error:", err.message));
//   socket.on("chat_error", (err: any) => {
//     const message = err?.message ?? (typeof err === "string" ? err : undefined);
//     console.error("❌ Chat error:", message ?? err ?? "<no payload>");
//   });

//   socket.io.on("reconnect", (attempt) => console.log(`🔄 Socket reconnected after ${attempt} attempts`));
//   socket.io.on("reconnect_attempt", (attempt) => console.log(`🔄 Reconnect attempt ${attempt}`));
//   socket.io.on("reconnect_error", (err) => console.error("❌ Reconnect error:", err));
//   socket.io.on("reconnect_failed", () => console.error("❌ Reconnect failed"));

//   window.__socket = socket;
//   window.__socketUser = { userId, role, token: resolvedToken };

//   return socket;
// }

// export function disconnectSocket() {
//   if (typeof window === "undefined") return;
//   if (window.__socket) {
//     window.__socket.removeAllListeners();
//     window.__socket.disconnect();
//   }
//   window.__socket = undefined;
//   window.__socketUser = undefined;
//   console.log("🔌 Socket disconnected");
// }

// const socket = getSocket();
// export { socket };
// export default socket;


import { io, Socket } from "socket.io-client"

const SOCKET_URL = process.env.NEXT_PUBLIC_SOCKET_URL || "http://localhost:3001"

let _socket: Socket | null = null

export function getSocket(token: string): Socket {
  if (_socket) return _socket 

  _socket = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: { token },
    reconnection: true,      
    reconnectionAttempts: 5,
  })
  return _socket
}

export function disconnectSocket() {
  _socket?.disconnect()
  _socket = null
}